import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  listaProd: any;
  usuario: any;
  tipo: string;
  pass = false;
  public usr = this.authSvc.afAuth.user;

  loginForm = new FormGroup ({
    email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
  });

  get emailNoValido() {
    return this.loginForm.get('email').invalid && this.loginForm.get('email').touched;
  }
  get passwordNoValido() {
    return this.loginForm.get('password').invalid && this.loginForm.get('password').touched;
  }

  constructor(private prodSvc: ProductosService,
              private router: Router,
              private authSvc: AuthService) {
  }

  ngOnInit(): void {

  }


  registrar(tipo: string){
    console.log(tipo);
    this.router.navigate([`registro/${tipo}`]);
  }

  onLogin(){
    const {email, password } = this.loginForm.value;
    try {
      const user = this.authSvc.login(email, password);
      if (user) {
        user.then(usr => {
          const idUser = usr.user.uid;
          this.authSvc.consultarTipoUsuario(idUser)
                      .subscribe(res => {
                        this.usuario = res;
                        console.log(this.usuario);
                        this.tipo = this.usuario.tipo;
                        if (this.tipo === 'Administrador') {
                          this.router.navigate(['administracion']);
                        } else {
                          this.router.navigate(['productos']);
                        }
                      });
        }).catch(err => {
          Swal.fire({
            title: 'Error...',
            text: 'Email o contraseña inválidos, verifique',
            icon: 'error',
            allowOutsideClick: false,
            showCloseButton: true
          });
        });
      }
    } catch (error) {
    }
  }
  activarPass(){
    this.pass = true;
  }

  desactivarPass(){
    this.pass = false;
  }

  contrasena(){
    this.router.navigate(['contrasena']);
  }

}
